// src/components/MapComponent.jsx
import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import carIconUrl from '../assets/car-icon.png';

const carIcon = new L.Icon({
  iconUrl: carIconUrl,
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
});

// Fit all markers into view
function FitBounds({ positions }) {
  const map = useMap();
  useEffect(() => {
    if (!positions.length) return;
    const bounds = L.latLngBounds(positions);
    map.fitBounds(bounds, { padding: [50, 50] });
  }, [map, positions]);
  return null;
}

// Utility: Move ~50m randomly
function moveRandomly([lat, lng]) {
  const meters = 50;
  const earth = 6378e3;

  const deltaLat = (Math.random() - 0.5) * (meters / earth) * (180 / Math.PI);
  const deltaLng =
    (Math.random() - 0.5) *
    (meters / earth) *
    (180 / Math.PI) /
    Math.cos((lat * Math.PI) / 180);

  return [lat + deltaLat, lng + deltaLng];
}

export function MapComponent() {
  const [vehicles, setVehicles] = useState([]);
  const [userCenter, setUserCenter] = useState(null);
  const [loading, setLoading] = useState(true);

  // Get user location
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        setUserCenter([latitude, longitude]);

        // Load dummy data near user
        const dummy = [
          { id: 1, label: 'Cab A', coords: moveRandomly([latitude, longitude]) },
          { id: 2, label: 'Cab B', coords: moveRandomly([latitude, longitude]) },
          { id: 3, label: 'Cab C', coords: moveRandomly([latitude, longitude]) },
          { id: 4, label: 'Cab D', coords: moveRandomly([latitude, longitude]) },
        ];
        setVehicles(dummy);
        setLoading(false);
      },
      (err) => {
        console.error('Geolocation error:', err);

        // fallback center (Bangalore)
        const fallback = [12.9716, 77.5946];
        setUserCenter(fallback);

        const dummy = [
          { id: 1, label: 'Cab A', coords: moveRandomly(fallback) },
          { id: 2, label: 'Cab B', coords: moveRandomly(fallback) },
          { id: 3, label: 'Cab C', coords: moveRandomly(fallback) },
          { id: 4, label: 'Cab D', coords: moveRandomly(fallback) },
        ];
        setVehicles(dummy);
        setLoading(false);
      }
    );
  }, []);

  // Simulate movement every 2 seconds
  useEffect(() => {
    if (vehicles.length === 0) return;

    const interval = setInterval(() => {
      setVehicles((prev) =>
        prev.map((v) => ({
          ...v,
          coords: moveRandomly(v.coords),
        }))
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [vehicles]);

  const positions = vehicles.map((v) => v.coords);
  const center = userCenter || [12.9716, 77.5946];

  if (loading) return <div className="text-center p-6">📍 Loading map...</div>;

  return (
    <MapContainer
  
      center={center}
      zoom={15}
      scrollWheelZoom
      className="w-full h-full z-0"
    >
      <TileLayer
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {vehicles.map(({ id, coords, label }) => (
        <Marker key={id} position={coords} icon={carIcon}>
          <Popup>
            {label}<br />
            {coords[0].toFixed(5)}, {coords[1].toFixed(5)}
          </Popup>
        </Marker>
      ))}

      <FitBounds positions={positions} />
    </MapContainer>
  );
}
